<button mat-raised-button #refBut *ngIf="type==='raised'"></button>
<button mat-stroked-button #refBut *ngIf="type==='stroked'"></button>
<button mat-button #refBut *ngIf="type==='basic' || type==='common'"></button>
<button mat-flat-button #refBut *ngIf="type==='flat'"></button>
<button mat-fab #refBut *ngIf="type==='fab'"></button>
<button mat-menu-item  *ngIf="type =='item'">
        <ng-content></ng-content>
</button>
<button mat-icon-button #refBut *ngIf="type =='icon'">
        <ng-content></ng-content>
</button>